// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__eMbYT","title":"Info_title__2sVtR","links":"Info_links__1nVVG","link":"Info_link__HBN0V","logo":"Info_logo__3tebD"};